<!-- Documents -->
<div *ngFor="let file of filteredFiles; let index = index; trackBy:fileByIdOrName"
    class="flex justify-between items-center file-row min-h-[50px]"
    [ngClass]="{'pending': file.status === 'processing' || file.status === 'retry' || file.status === 'queued', 'min-h-[60px]': file.subText !== undefined}">
    <!-- Icon and title -->
    <div class="flex items-start gap-[7px] overflow-hidden ">
        <mat-icon *ngIf="file.status === 'processing'" svgIcon="file-clock"
            class="h-5 w-5 shrink-0 text-app-global-text-secondary"></mat-icon>
        <mat-icon *ngIf="file.status === 'failed'" svgIcon="file-warning"
            class="h-5 w-5 shrink-0 text-app-global-warning"></mat-icon>
        <mat-icon *ngIf="file.status === 'available'" svgIcon="file"
            class="h-5 w-5 shrink-0 text-app-global-primary"></mat-icon>
        <mat-icon *ngIf="file.status === 'queued' || file.status === 'retry'" svgIcon="file-up"
            class="h-5 w-5 shrink-0 text-app-global-text-secondary" i18n-matTooltip
            matTooltip="Dit bestand wordt verwerkt na het opslaan"></mat-icon>
        <div class="flex flex-col min-w-0 gap-[2px]">
            <p class="text-app-global-primary text-base overflow-hidden text-ellipsis whitespace-nowrap document-title"
                [ngClass]="{
                'text-app-global-warning': file.status === 'failed',
            }" [matTooltip]="file.file.name" tooltipOnOverflow>
                {{file.file.name}}
            </p>
            <p *ngIf="file.subText"
                class="text-app-global-text-secondary text-sm overflow-hidden text-ellipsis whitespace-nowrap"
                [matTooltip]="file.subText" tooltipOnOverflow>
                {{ file.subText }}
            </p>
        </div>
    </div>
    <!-- Actions -->
    <div class="flex shrink-0">
        <!-- Download -->
        <button mat-icon-button aria-label="Bestand downloaden" (click)="downloadFile(file)" *ngIf="download"
            class="scale-[0.8] action-button">
            <mat-icon svgIcon="download" class="text-app-global-primary shrink-0 scale-[1.2]"></mat-icon>
        </button>
        <!-- View -->
        <button mat-icon-button aria-label="Bestand bekijken" (click)="viewFile(file)"
            *ngIf="view && (file.file.name | canViewFileInBrowser)" class="scale-[0.8] action-button">
            <mat-icon svgIcon="eye" class="text-app-global-primary shrink-0 scale-[1.2]"></mat-icon>
        </button>
        <!-- Delete -->
        <button mat-icon-button aria-label="Bestand verwijderen" (click)="deleteFile(index)" *ngIf="delete"
            class="scale-[0.8] action-button delete-button">
            <mat-icon svgIcon="trash-2" class="text-app-global-warning shrink-0 scale-[1.2]"></mat-icon>
        </button>
    </div>
</div>

<!-- Paginator -->
<mat-paginator [pageSize]="10" [hidePageSize]="true" [ngClass]="{'hidden': !control?.value?.length}"
    class="paginator-hidden">
</mat-paginator>